
/*
 * THIS FILE IS AUTOGENERATED DO NOT EDIT (by schema_gen.js)
 */

(window as any).getMessagesSchemas = function() {
  return [

["AgencyMemberAuthInfo",
{
  "type": "object",
  "properties": {
    "agencyMemberAccessKey": {
      "type": "string"
    },
    "agency": {
      "$ref": "#/definitions/Agency"
    },
    "agencyMember": {
      "$ref": "#/definitions/AgencyMember"
    }
  },
  "required": [
    "agency",
    "agencyMember",
    "agencyMemberAccessKey"
  ],
  "definitions": {
    "Agency": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyId"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "logoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "website": {
          "type": [
            "null",
            "string"
          ]
        },
        "address": {
          "type": [
            "null",
            "string"
          ]
        },
        "officePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "organizationType": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address",
        "createdAt",
        "id",
        "logoUrl",
        "name",
        "officePhone",
        "organizationType",
        "website"
      ]
    },
    "AgencyId": {
      "type": "number"
    },
    "AgencyMember": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/AgencyMemberId"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "agencyAdmin": {
          "type": "boolean"
        },
        "jobTitle": {
          "type": "string"
        },
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "agencyAdmin",
        "createdAt",
        "email",
        "firstName",
        "id",
        "jobTitle",
        "lastName",
        "photoUrl"
      ]
    },
    "AgencyMemberId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRLogoutTimer",
{
  "type": "object",
  "properties": {
    "milliseconds": {
      "type": "number"
    }
  },
  "required": [
    "milliseconds"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRApplicationForm",
{
  "type": "object",
  "properties": {
    "sections": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/HRSection"
      }
    },
    "settings": {
      "$ref": "#/definitions/HRApplicationFormSettings"
    },
    "caregiverSectionStageId": {
      "anyOf": [
        {
          "$ref": "#/definitions/HRSectionStageId"
        },
        {
          "type": "null"
        }
      ]
    },
    "caregiverSectionStageLabel": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "caregiverSectionStageId",
    "caregiverSectionStageLabel",
    "sections",
    "settings"
  ],
  "definitions": {
    "HRSection": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRSectionData"
        },
        "subSections": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRSubSection"
          }
        }
      },
      "required": [
        "data",
        "subSections"
      ]
    },
    "HRSectionData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRSectionId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        },
        "isStop": {
          "type": "boolean"
        },
        "HRSectionStageId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRSectionStageId"
            },
            {
              "type": "null"
            }
          ]
        },
        "HRSectionStageLabel": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "HRSectionStageId",
        "HRSectionStageLabel",
        "id",
        "isStop",
        "subtitle",
        "title"
      ]
    },
    "HRSectionId": {
      "type": "number"
    },
    "HRSectionStageId": {
      "type": "number"
    },
    "HRSubSection": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRSubSectionData"
        },
        "document": {
          "anyOf": [
            {
              "$ref": "#/definitions/SubsectionDocumentData"
            },
            {
              "type": "null"
            }
          ]
        },
        "questionGroups": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRQuestionGroup"
          }
        }
      },
      "required": [
        "data",
        "document",
        "questionGroups"
      ]
    },
    "HRSubSectionData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRSubSectionId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        },
        "settings": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRSubSectionSettings"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "id",
        "settings",
        "subtitle",
        "title"
      ]
    },
    "HRSubSectionId": {
      "type": "number"
    },
    "HRSubSectionSettings": {
      "type": "object",
      "properties": {
        "testSettings": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRTestSettings"
            },
            {
              "type": "null"
            }
          ]
        },
        "availabilityPlaceholder": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRAvailabilityPlaceholderSettings"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "availabilityPlaceholder",
        "testSettings"
      ]
    },
    "HRTestSettings": {
      "type": "object",
      "properties": {
        "testFailText": {
          "type": "string"
        },
        "testSuccessText": {
          "type": "string"
        },
        "testRetryText": {
          "type": "string"
        },
        "maxWrongAnswers": {
          "type": "number"
        },
        "testMaxTries": {
          "type": "number"
        },
        "shouldShowWrongAnswers": {
          "type": "boolean"
        }
      },
      "required": [
        "maxWrongAnswers",
        "shouldShowWrongAnswers",
        "testFailText",
        "testMaxTries",
        "testRetryText",
        "testSuccessText"
      ]
    },
    "HRAvailabilityPlaceholderSettings": {
      "type": "object",
      "properties": {
        "showHoursQuestion": {
          "type": "boolean"
        },
        "showDistanceQuestion": {
          "type": "boolean"
        }
      },
      "required": [
        "showDistanceQuestion",
        "showHoursQuestion"
      ]
    },
    "SubsectionDocumentData": {
      "type": "object",
      "properties": {
        "isDocumentGenerated": {
          "type": "boolean"
        },
        "doc": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "doc",
        "isDocumentGenerated"
      ]
    },
    "HRQuestionGroup": {
      "type": "object",
      "properties": {
        "data": {
          "$ref": "#/definitions/HRQuestionGroupData"
        },
        "questions": {
          "type": "array",
          "items": {
            "anyOf": [
              {
                "$ref": "#/definitions/HRQuestion.TextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.AddressQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.EmailQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.NumericQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DollarQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.PhoneNumberQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.SSNQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.FullDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.BirthDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.MonthYearDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.YearDateQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.RadioQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DropDownQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.CheckboxQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.SignatureQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.GeneralSignatureQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.StartAndEndTimeQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.StarQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.Placeholder"
              },
              {
                "$ref": "#/definitions/HRQuestion.TitleText"
              },
              {
                "$ref": "#/definitions/HRQuestion.PlainText"
              },
              {
                "$ref": "#/definitions/HRQuestion.DocumentQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DocumentWithExpiryQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.AmericanTestQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.FreeTextQuestion"
              },
              {
                "$ref": "#/definitions/HRQuestion.DownloadableFileQuestion"
              }
            ]
          }
        }
      },
      "required": [
        "data",
        "questions"
      ]
    },
    "HRQuestionGroupData": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRQuestionGroupId"
        },
        "title": {
          "type": "string"
        },
        "subtitle": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "id",
        "subtitle",
        "title"
      ]
    },
    "HRQuestionGroupId": {
      "type": "number"
    },
    "HRQuestion.TextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Text"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestionId": {
      "type": "number"
    },
    "HRQuestionTemplateId": {
      "type": "string"
    },
    "HRQuestion.AddressQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Address"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.EmailQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Email"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.NumericQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Numeric"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DollarQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Dollar"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.PhoneNumberQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PhoneNumber"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.SSNQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "SSN"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.FullDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FullDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.BirthDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "BirthDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.MonthYearDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "MonthYearDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.YearDateQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "YearDate"
          ]
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.RadioQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Radio"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "chosenAnswerId",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "textId",
        "type"
      ]
    },
    "PossibleAnswer": {
      "type": "object",
      "properties": {
        "id": {
          "type": "number"
        },
        "text": {
          "type": "string"
        }
      },
      "required": [
        "id",
        "text"
      ]
    },
    "HRQuestion.DropDownQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DropDown"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "chosenAnswerId",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.CheckboxQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Checkbox"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "chosenAnswerIds": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "number"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "chosenAnswerIds",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.SignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Signature"
          ]
        },
        "answer": {
          "description": "base64 data-url png of signature",
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.GeneralSignatureQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "GeneralSignature"
          ]
        },
        "answer": {
          "description": "base64 data-url png of signature",
          "anyOf": [
            {
              "$ref": "#/definitions/GeneralSignatureAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "GeneralSignatureAnswer": {
      "type": "object",
      "properties": {
        "signature": {
          "type": [
            "null",
            "string"
          ]
        },
        "generalSignaturePerson": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "generalSignaturePerson",
        "signature"
      ]
    },
    "HRQuestion.StartAndEndTimeQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "StartAndEndTime"
          ]
        },
        "answer": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "startTime": {
                  "type": "number"
                },
                "endTime": {
                  "type": "number"
                }
              },
              "required": [
                "endTime",
                "startTime"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.StarQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Star"
          ]
        },
        "answer": {
          "type": [
            "null",
            "number"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.Placeholder": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Placeholder"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.TitleText": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "TitleText"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.PlainText": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "PlainText"
          ]
        },
        "isMandatory": {
          "type": "boolean",
          "enum": [
            false
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DocumentQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "Document"
          ]
        },
        "answer": {
          "description": "data uri",
          "type": [
            "null",
            "string"
          ]
        },
        "documentTypeToUpload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            {
              "type": "null"
            }
          ]
        },
        "canUploadFromGallery": {
          "type": "boolean"
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "canUploadFromGallery",
        "documentTypeToUpload",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "CaregiverDocumentTypeId": {
      "type": "number"
    },
    "HRQuestion.DocumentWithExpiryQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DocumentWithExpiry"
          ]
        },
        "answer": {
          "description": "data uri",
          "anyOf": [
            {
              "$ref": "#/definitions/DocumentWithExpiryAnswer"
            },
            {
              "type": "null"
            }
          ]
        },
        "documentTypeToUpload": {
          "anyOf": [
            {
              "$ref": "#/definitions/CaregiverDocumentTypeId"
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "documentTypeToUpload",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "DocumentWithExpiryAnswer": {
      "type": "object",
      "properties": {
        "document": {
          "type": "string"
        },
        "expiryDate": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "document",
        "expiryDate"
      ]
    },
    "HRQuestion.AmericanTestQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "AmericanTest"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "chosenAnswerId": {
          "type": [
            "null",
            "number"
          ]
        },
        "correctAnswer": {
          "type": "number"
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "chosenAnswerId",
        "correctAnswer",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.FreeTextQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "FreeText"
          ]
        },
        "possibleAnswers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PossibleAnswer"
          }
        },
        "chosenAnswerIds": {
          "anyOf": [
            {
              "type": "array",
              "items": {
                "type": "number"
              }
            },
            {
              "type": "null"
            }
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "chosenAnswerIds",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "possibleAnswers",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRQuestion.DownloadableFileQuestion": {
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": [
            "DownloadableFile"
          ]
        },
        "downloaded": {
          "type": "boolean"
        },
        "answer": {
          "type": [
            "null",
            "string"
          ]
        },
        "id": {
          "$ref": "#/definitions/HRQuestionId"
        },
        "textId": {
          "$ref": "#/definitions/HRQuestionTemplateId"
        },
        "questionText": {
          "type": "string"
        },
        "isMandatory": {
          "type": "boolean"
        },
        "parentId": {
          "anyOf": [
            {
              "$ref": "#/definitions/HRQuestionId"
            },
            {
              "type": "null"
            }
          ]
        },
        "parentAnswer": {
          "type": [
            "null",
            "string"
          ]
        },
        "isHidden": {
          "type": "boolean"
        }
      },
      "required": [
        "answer",
        "downloaded",
        "id",
        "isHidden",
        "isMandatory",
        "parentAnswer",
        "parentId",
        "questionText",
        "textId",
        "type"
      ]
    },
    "HRApplicationFormSettings": {
      "type": "object",
      "properties": {
        "certificationSettings": {
          "anyOf": [
            {
              "$ref": "#/definitions/CertificationSettings"
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "certificationSettings"
      ]
    },
    "CertificationSettings": {
      "type": "object",
      "properties": {
        "locationPayRates": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/HRCertificationPayRate"
          }
        }
      },
      "required": [
        "locationPayRates"
      ]
    },
    "HRCertificationPayRate": {
      "type": "object",
      "properties": {
        "locationGroup": {
          "type": "string"
        },
        "counties": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "rates": {
          "$ref": "#/definitions/HRCertificationPayRates"
        },
        "supplementals": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/PayRateSupplemental"
          }
        }
      },
      "required": [
        "counties",
        "locationGroup",
        "rates",
        "supplementals"
      ]
    },
    "HRCertificationPayRates": {
      "type": "object",
      "properties": {
        "hourlyRate": {
          "type": "number"
        },
        "dailyRate": {
          "type": "number"
        },
        "overtimeRate": {
          "type": "number"
        },
        "visitRate": {
          "type": "number"
        },
        "payRange": {
          "type": [
            "null",
            "string"
          ]
        },
        "additionalWage": {
          "type": [
            "null",
            "number"
          ]
        },
        "baseWage": {
          "type": [
            "null",
            "number"
          ]
        },
        "supplementalWage": {
          "type": [
            "null",
            "number"
          ]
        },
        "workShiftLine1Rate": {
          "type": [
            "null",
            "number"
          ]
        },
        "workShiftLine1Label": {
          "type": [
            "null",
            "string"
          ]
        },
        "workShiftLine2Rate": {
          "type": [
            "null",
            "number"
          ]
        },
        "workShiftLine2Label": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "additionalWage",
        "baseWage",
        "dailyRate",
        "hourlyRate",
        "overtimeRate",
        "payRange",
        "supplementalWage",
        "visitRate",
        "workShiftLine1Label",
        "workShiftLine1Rate",
        "workShiftLine2Label",
        "workShiftLine2Rate"
      ]
    },
    "PayRateSupplemental": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/PayRateSupplementalId"
        },
        "state": {
          "type": "string"
        },
        "groupName": {
          "type": "string"
        },
        "hourlyRate": {
          "type": "number"
        },
        "type": {
          "type": "string"
        },
        "agencyName": {
          "type": "string"
        },
        "agencyDescription": {
          "type": "string"
        }
      },
      "required": [
        "agencyDescription",
        "agencyName",
        "groupName",
        "hourlyRate",
        "id",
        "state",
        "type"
      ]
    },
    "PayRateSupplementalId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRAnswerResult",
{
  "type": "object",
  "properties": {
    "isSuccessful": {
      "type": "boolean"
    },
    "reason": {
      "type": "string"
    }
  },
  "required": [
    "isSuccessful"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["NullableCaregiverAvailability",
{
  "description": "nullable wrapper for CaregiverAvailability",
  "type": "object",
  "properties": {
    "caregiverAvailability": {
      "anyOf": [
        {
          "$ref": "#/definitions/CaregiverAvailability"
        },
        {
          "type": "null"
        }
      ]
    }
  },
  "required": [
    "caregiverAvailability"
  ],
  "definitions": {
    "CaregiverAvailability": {
      "description": "when is the caregiver available, and to which visits",
      "type": "object",
      "properties": {
        "dayAvailabilities": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/DayAvailability"
          }
        },
        "maxDistance": {
          "description": "in miles",
          "type": "integer",
          "minimum": 1,
          "maximum": 99
        },
        "minDuration": {
          "description": "in hours",
          "type": "integer",
          "minimum": 1,
          "maximum": 24
        },
        "maxDuration": {
          "description": "in hours, between 1 and 24",
          "type": "integer",
          "minimum": 1,
          "maximum": 24
        }
      },
      "required": [
        "dayAvailabilities",
        "maxDistance",
        "maxDuration",
        "minDuration"
      ]
    },
    "DayAvailability": {
      "description": "when is the caregiver available during each day",
      "type": "object",
      "properties": {
        "day": {
          "description": "0 = sunday, 1 = monday, ... , 6 = saturday",
          "type": "integer",
          "minimum": 0,
          "maximum": 6
        },
        "startHour": {
          "description": "24-hour time",
          "minimum": 0,
          "maximum": 24,
          "type": "number"
        },
        "endHour": {
          "description": "24-hour time",
          "minimum": 0,
          "maximum": 24,
          "type": "number"
        },
        "busyAllDay": {
          "type": "boolean"
        }
      },
      "required": [
        "busyAllDay",
        "day",
        "endHour",
        "startHour"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["CaregiverLoginResponse",
{
  "type": "object",
  "properties": {
    "authToken": {
      "type": "string"
    },
    "pusherAppKey": {
      "description": "Use this to connect to the Pusher service, to get real time updates",
      "type": [
        "null",
        "string"
      ]
    },
    "pusherCluster": {
      "description": "The pusher client should be configured to connect to this cluster",
      "type": [
        "null",
        "string"
      ]
    },
    "pusherChannelName": {
      "description": "After connecting to the Pusher service, subscribe to this channel",
      "type": [
        "null",
        "string"
      ]
    },
    "caregiver": {
      "$ref": "#/definitions/Caregiver"
    },
    "caregiverId": {
      "type": "number"
    }
  },
  "definitions": {
    "Caregiver": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "status": {
          "$ref": "#/definitions/CaregiverStatus"
        },
        "caregiverCode": {
          "type": [
            "null",
            "string"
          ]
        },
        "caregiverBranch": {
          "type": [
            "null",
            "string"
          ]
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "birthDate": {
          "format": "date-time",
          "type": [
            "null",
            "string"
          ]
        },
        "birthDateDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "phoneNumber": {
          "type": "string"
        },
        "phoneNumbers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverPhoneNumber"
          }
        },
        "homePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "middleName": {
          "type": [
            "null",
            "string"
          ]
        },
        "gender": {
          "description": "\"M\", \"F\"",
          "type": "string"
        },
        "languages": {
          "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "address": {
          "type": "string"
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        },
        "addressGeoLocation": {
          "$ref": "#/definitions/Geo"
        },
        "addressComponents": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "installedUserAgent": {
          "type": [
            "null",
            "string"
          ]
        },
        "appInstalledDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "appInstalled": {
          "type": "boolean"
        },
        "online": {
          "description": "Is the caregiver's app currently open",
          "type": "boolean"
        },
        "lastSeen": {
          "description": "When was the last time the caregiver was online?",
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "notificationSettings": {
          "$ref": "#/definitions/NotificationSettings"
        },
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "officeIds": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/OfficeId"
          }
        }
      },
      "required": [
        "address",
        "addressGeoLocation",
        "appInstalled",
        "appInstalledDate",
        "birthDate",
        "birthDateDate",
        "caregiverCode",
        "certifications",
        "createdAt",
        "email",
        "firstName",
        "gender",
        "id",
        "installedUserAgent",
        "languages",
        "lastName",
        "lastSeen",
        "officeIds",
        "online",
        "phoneNumber",
        "phoneNumbers",
        "photoUrl",
        "status"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "NotificationSettings": {
      "type": "object",
      "properties": {
        "receiveVisitNotifications": {
          "type": "boolean"
        }
      },
      "required": [
        "receiveVisitNotifications"
      ]
    },
    "OfficeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRCaregiverLoginResponse",
{
  "type": "object",
  "properties": {
    "agencyOffices": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/Office"
      }
    },
    "agencyHRCertifications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverCertification"
      }
    },
    "authToken": {
      "type": "string"
    },
    "pusherAppKey": {
      "description": "Use this to connect to the Pusher service, to get real time updates",
      "type": [
        "null",
        "string"
      ]
    },
    "pusherCluster": {
      "description": "The pusher client should be configured to connect to this cluster",
      "type": [
        "null",
        "string"
      ]
    },
    "pusherChannelName": {
      "description": "After connecting to the Pusher service, subscribe to this channel",
      "type": [
        "null",
        "string"
      ]
    },
    "caregiver": {
      "$ref": "#/definitions/Caregiver"
    },
    "caregiverId": {
      "type": "number"
    }
  },
  "required": [
    "agencyHRCertifications",
    "agencyOffices"
  ],
  "definitions": {
    "Caregiver": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/CaregiverId"
        },
        "status": {
          "$ref": "#/definitions/CaregiverStatus"
        },
        "caregiverCode": {
          "type": [
            "null",
            "string"
          ]
        },
        "caregiverBranch": {
          "type": [
            "null",
            "string"
          ]
        },
        "createdAt": {
          "$ref": "#/definitions/Instant"
        },
        "birthDate": {
          "format": "date-time",
          "type": [
            "null",
            "string"
          ]
        },
        "birthDateDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/LocalDate"
            },
            {
              "type": "null"
            }
          ]
        },
        "phoneNumber": {
          "type": "string"
        },
        "phoneNumbers": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverPhoneNumber"
          }
        },
        "homePhone": {
          "type": [
            "null",
            "string"
          ]
        },
        "firstName": {
          "type": "string"
        },
        "lastName": {
          "type": "string"
        },
        "middleName": {
          "type": [
            "null",
            "string"
          ]
        },
        "gender": {
          "description": "\"M\", \"F\"",
          "type": "string"
        },
        "languages": {
          "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "address": {
          "type": "string"
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        },
        "addressGeoLocation": {
          "$ref": "#/definitions/Geo"
        },
        "addressComponents": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "certifications": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/CaregiverCertification"
          }
        },
        "photoUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "installedUserAgent": {
          "type": [
            "null",
            "string"
          ]
        },
        "appInstalledDate": {
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "appInstalled": {
          "type": "boolean"
        },
        "online": {
          "description": "Is the caregiver's app currently open",
          "type": "boolean"
        },
        "lastSeen": {
          "description": "When was the last time the caregiver was online?",
          "anyOf": [
            {
              "$ref": "#/definitions/Instant"
            },
            {
              "type": "null"
            }
          ]
        },
        "notificationSettings": {
          "$ref": "#/definitions/NotificationSettings"
        },
        "email": {
          "type": [
            "null",
            "string"
          ]
        },
        "officeIds": {
          "type": "array",
          "items": {
            "$ref": "#/definitions/OfficeId"
          }
        }
      },
      "required": [
        "address",
        "addressGeoLocation",
        "appInstalled",
        "appInstalledDate",
        "birthDate",
        "birthDateDate",
        "caregiverCode",
        "certifications",
        "createdAt",
        "email",
        "firstName",
        "gender",
        "id",
        "installedUserAgent",
        "languages",
        "lastName",
        "lastSeen",
        "officeIds",
        "online",
        "phoneNumber",
        "phoneNumbers",
        "photoUrl",
        "status"
      ]
    },
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "NotificationSettings": {
      "type": "object",
      "properties": {
        "receiveVisitNotifications": {
          "type": "boolean"
        }
      },
      "required": [
        "receiveVisitNotifications"
      ]
    },
    "OfficeId": {
      "type": "number"
    },
    "Office": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/OfficeId"
        },
        "name": {
          "type": "string"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "active": {
          "type": "boolean"
        },
        "address": {
          "type": "string"
        },
        "addressComponents": {
          "anyOf": [
            {
              "$ref": "#/definitions/AddressComponents"
            },
            {
              "type": "null"
            }
          ]
        },
        "timezone": {
          "type": "string"
        },
        "hhaExternalIds": {
          "type": [
            "null",
            "string"
          ]
        },
        "phoneNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "tax_id": {
          "type": [
            "null",
            "string"
          ]
        },
        "npi": {
          "type": [
            "null",
            "string"
          ]
        },
        "provider_id": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "active",
        "address",
        "addressComponents",
        "agencyId",
        "id",
        "name",
        "npi",
        "phoneNumber",
        "provider_id",
        "tax_id",
        "timezone"
      ]
    },
    "AgencyId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRAppTemporaryDocument",
{
  "type": "object",
  "properties": {
    "title": {
      "type": "string"
    },
    "url": {
      "type": "string"
    },
    "key": {
      "type": "string"
    },
    "bucket": {
      "type": "string"
    },
    "signedAt": {
      "type": "string"
    },
    "docType": {
      "type": [
        "null",
        "number"
      ]
    }
  },
  "required": [
    "bucket",
    "docType",
    "key",
    "signedAt",
    "title",
    "url"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRAppDocuments",
{
  "type": "object",
  "properties": {
    "documents": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/HRAppDocument"
      }
    }
  },
  "required": [
    "documents"
  ],
  "definitions": {
    "HRAppDocument": {
      "type": "object",
      "properties": {
        "title": {
          "type": "string"
        },
        "url": {
          "type": "string"
        },
        "signedAt": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "signedAt",
        "title",
        "url"
      ]
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["Caregiver",
{
  "type": "object",
  "properties": {
    "id": {
      "$ref": "#/definitions/CaregiverId"
    },
    "status": {
      "$ref": "#/definitions/CaregiverStatus"
    },
    "caregiverCode": {
      "type": [
        "null",
        "string"
      ]
    },
    "caregiverBranch": {
      "type": [
        "null",
        "string"
      ]
    },
    "createdAt": {
      "$ref": "#/definitions/Instant"
    },
    "birthDate": {
      "format": "date-time",
      "type": [
        "null",
        "string"
      ]
    },
    "birthDateDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/LocalDate"
        },
        {
          "type": "null"
        }
      ]
    },
    "phoneNumber": {
      "type": "string"
    },
    "phoneNumbers": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverPhoneNumber"
      }
    },
    "homePhone": {
      "type": [
        "null",
        "string"
      ]
    },
    "firstName": {
      "type": "string"
    },
    "lastName": {
      "type": "string"
    },
    "middleName": {
      "type": [
        "null",
        "string"
      ]
    },
    "gender": {
      "description": "\"M\", \"F\"",
      "type": "string"
    },
    "languages": {
      "description": "Each element must be one of 'Caregiver.ALL_LANGUAGES'",
      "type": "array",
      "items": {
        "type": "string"
      }
    },
    "address": {
      "type": "string"
    },
    "address2": {
      "type": [
        "null",
        "string"
      ]
    },
    "addressGeoLocation": {
      "$ref": "#/definitions/Geo"
    },
    "addressComponents": {
      "anyOf": [
        {
          "$ref": "#/definitions/AddressComponents"
        },
        {
          "type": "null"
        }
      ]
    },
    "certifications": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/CaregiverCertification"
      }
    },
    "photoUrl": {
      "type": [
        "null",
        "string"
      ]
    },
    "installedUserAgent": {
      "type": [
        "null",
        "string"
      ]
    },
    "appInstalledDate": {
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "appInstalled": {
      "type": "boolean"
    },
    "online": {
      "description": "Is the caregiver's app currently open",
      "type": "boolean"
    },
    "lastSeen": {
      "description": "When was the last time the caregiver was online?",
      "anyOf": [
        {
          "$ref": "#/definitions/Instant"
        },
        {
          "type": "null"
        }
      ]
    },
    "notificationSettings": {
      "$ref": "#/definitions/NotificationSettings"
    },
    "email": {
      "type": [
        "null",
        "string"
      ]
    },
    "officeIds": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/OfficeId"
      }
    }
  },
  "required": [
    "address",
    "addressGeoLocation",
    "appInstalled",
    "appInstalledDate",
    "birthDate",
    "birthDateDate",
    "caregiverCode",
    "certifications",
    "createdAt",
    "email",
    "firstName",
    "gender",
    "id",
    "installedUserAgent",
    "languages",
    "lastName",
    "lastSeen",
    "officeIds",
    "online",
    "phoneNumber",
    "phoneNumbers",
    "photoUrl",
    "status"
  ],
  "definitions": {
    "CaregiverId": {
      "type": "number"
    },
    "CaregiverStatus": {
      "description": "The status of a Caregiver within a specific Agency",
      "enum": [
        "ACTIVE",
        "JOIN_REQUEST",
        "ON_HOLD",
        "ON_LEAVE",
        "PENDING",
        "SUSPENDED",
        "TERMINATED"
      ],
      "type": "string"
    },
    "Instant": {
      "type": "string",
      "xreviver": "JSJoda.Instant"
    },
    "LocalDate": {
      "type": "string",
      "xreviver": "JSJoda.LocalDate"
    },
    "CaregiverPhoneNumber": {
      "type": "object",
      "properties": {
        "phoneNumber": {
          "type": "string"
        },
        "type": {
          "type": "string"
        }
      },
      "required": [
        "phoneNumber",
        "type"
      ]
    },
    "Geo": {
      "type": "object",
      "properties": {
        "lat": {
          "type": "number"
        },
        "lng": {
          "type": "number"
        }
      },
      "required": [
        "lat",
        "lng"
      ]
    },
    "AddressComponents": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "country": {
          "type": "string"
        },
        "administrativeAreaLevel1": {
          "type": "string"
        },
        "administrativeAreaLevel2": {
          "type": "string"
        },
        "sublocalityLevel1": {
          "type": [
            "null",
            "string"
          ]
        },
        "neighborhood": {
          "type": [
            "null",
            "string"
          ]
        },
        "locality": {
          "type": [
            "null",
            "string"
          ]
        },
        "formatedAddressDetails": {
          "$ref": "#/definitions/FormatedAddressDetails"
        }
      },
      "required": [
        "administrativeAreaLevel1",
        "administrativeAreaLevel2",
        "country",
        "location"
      ]
    },
    "FormatedAddressDetails": {
      "type": "object",
      "properties": {
        "location": {
          "$ref": "#/definitions/Geo"
        },
        "address1": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "fullAddress": {
          "type": "string"
        },
        "city": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip5": {
          "type": [
            "null",
            "string"
          ]
        },
        "zip4": {
          "type": [
            "null",
            "string"
          ]
        },
        "street": {
          "type": [
            "null",
            "string"
          ]
        },
        "streetNumber": {
          "type": [
            "null",
            "string"
          ]
        },
        "crossStreet": {
          "type": [
            "null",
            "string"
          ]
        },
        "address2": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "address1",
        "country",
        "county",
        "fullAddress",
        "location",
        "state"
      ]
    },
    "CaregiverCertification": {
      "type": "string"
    },
    "NotificationSettings": {
      "type": "object",
      "properties": {
        "receiveVisitNotifications": {
          "type": "boolean"
        }
      },
      "required": [
        "receiveVisitNotifications"
      ]
    },
    "OfficeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRDocumentTypes",
{
  "type": "object",
  "properties": {
    "documentTypes": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/HRDocumentType"
      }
    }
  },
  "required": [
    "documentTypes"
  ],
  "definitions": {
    "HRDocumentType": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRDocumentTypeId"
        },
        "name": {
          "type": "string"
        },
        "expires": {
          "type": "boolean"
        },
        "exampleUrl": {
          "type": [
            "null",
            "string"
          ]
        },
        "isMandatory": {
          "type": "boolean"
        },
        "sectionLabel": {
          "type": [
            "null",
            "string"
          ]
        }
      },
      "required": [
        "exampleUrl",
        "expires",
        "id",
        "isMandatory",
        "name",
        "sectionLabel"
      ]
    },
    "HRDocumentTypeId": {
      "type": "number"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRDownloadableFilePreviewResponse",
{
  "type": "object",
  "properties": {
    "fileUrl": {
      "type": [
        "null",
        "string"
      ]
    }
  },
  "required": [
    "fileUrl"
  ],
  "definitions": {},
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["SectionStagesByCertificationResponse",
{
  "type": "object",
  "properties": {
    "stages": {
      "type": "array",
      "items": {
        "$ref": "#/definitions/HRSectionStage"
      }
    }
  },
  "required": [
    "stages"
  ],
  "definitions": {
    "HRSectionStage": {
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/definitions/HRSectionStageId"
        },
        "agencyId": {
          "$ref": "#/definitions/AgencyId"
        },
        "label": {
          "type": "string"
        },
        "order": {
          "type": "number"
        },
        "labelColor": {
          "type": "string"
        },
        "certification": {
          "$ref": "#/definitions/CaregiverCertification"
        }
      },
      "required": [
        "agencyId",
        "certification",
        "id",
        "label",
        "labelColor",
        "order"
      ]
    },
    "HRSectionStageId": {
      "type": "number"
    },
    "AgencyId": {
      "type": "number"
    },
    "CaregiverCertification": {
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}],

["HRNewCaregiverOfficeAndCertification",
{
  "type": "object",
  "properties": {
    "officeId": {
      "type": "number"
    },
    "certification": {
      "$ref": "#/definitions/CaregiverCertification"
    }
  },
  "required": [
    "certification"
  ],
  "definitions": {
    "CaregiverCertification": {
      "type": "string"
    }
  },
  "$schema": "http://json-schema.org/draft-07/schema#"
}]

  ];
};



// WEBPACK FOOTER //
// ./src/message_schemas.ts